<template>
    <div>
        <v-dialog v-model="value" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-form ref="editTeamForm" method="post" :action="form.action" @success="editSuccess">
                <input type="hidden" name="id" v-model="item.id">
                <v-card>
                    <v-toolbar dark color="primary" height="80">
                        <v-toolbar-title>{{formTitle}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="close_dialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="v-dialog-body">
                        <v-container grid-list-md>
                            <v-layout row wrap>

                                <v-flex xs12 v-show="form.errors.general!==''">
                                    <v-alert
                                            ref="general"
                                            :value="form.errors.general!==''"
                                            type="error"
                                    >
                                        {{form.errors.general}}
                                    </v-alert>
                                </v-flex>

                                <v-flex xs12 v-if="!isTeamOwner(item) && item.id">
                                    <v-alert
                                            :value="true"
                                            type="info"
                                    >
                                        Only team admin can edit the team information.
                                    </v-alert>
                                </v-flex>



                                <v-flex xs12>
                                    <v-text-field
                                        type="text"
                                        name="name"
                                        maxlength="255"
                                        :rules="[rules.required]"
                                        :error-messages="form.errors.name"
                                        :label="$t('team.name')"
                                        v-model="item.name"
                                        :disabled="(!isTeamOwner(item) && (item.id > 0))"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 v-show="(isTeamOwner(item))">
                                    <h4>{{$t('team.team_member')}} ({{item.members.length}})</h4>

                                    <div class="member-list-wrapper elevation-2" v-if="item.members.length">
                                        <v-list two-line>
                                            <template v-for="member in item.members">
                                                <v-list-tile
                                                        :key="member.id"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ member.name }}</v-list-tile-title>
                                                        <v-list-tile-sub-title>{{ member.email }}</v-list-tile-sub-title>
                                                    </v-list-tile-content>

                                                    <v-list-tile-action>
                                                        <v-btn icon ripple @click="kickMember(member)">
                                                            <v-icon color="grey lighten-1">delete</v-icon>
                                                        </v-btn>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                            </template>
                                        </v-list>
                                    </div>

                                    <v-alert
                                            v-else
                                            :value="true"
                                            type="info"
                                    >
                                        {{$t('general.no_record_found')}}
                                    </v-alert>
                                </v-flex>

                                <v-flex xs12 v-show="isTeamOwner(item)">
                                    <h4>{{$t('team.member_invited')}}
                                        ({{item.invited_users.length}})
                                        <v-btn color="success" small @click="openAddMemberDialog()">{{$t('team.invite_user')}}</v-btn>
                                    </h4>

                                    <div class="invited-list-wrapper elevation-2" v-if="item.invited_users.length">
                                        <v-list two-line class="pa-0 my-1">
                                            <template v-for="invited_user in item.invited_users">
                                                <v-list-tile
                                                    :key="invited_user.id"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{invited_user.email}}</v-list-tile-title>
                                                        <v-list-tile-sub-title style="display: flex;"><v-icon size="16">access_time</v-icon> {{invited_user.created_at}}</v-list-tile-sub-title>
                                                    </v-list-tile-content>

                                                    <v-list-tile-action>
                                                        <v-btn icon ripple @click="removeInvitation(invited_user)">
                                                            <v-icon color="grey lighten-1">delete</v-icon>
                                                        </v-btn>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                            </template>
                                        </v-list>
                                    </div>
                                    <v-alert
                                            v-else
                                            :value="true"
                                            type="info"
                                    >
                                        {{$t('general.no_record_found')}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat
                               v-show="isTeamOwner(item) || !item.id"
                               type="submit"
                               ref="submit"
                               :loading="form.loading"
                        >
                            {{$t('action.save')}}
                        </v-btn>
                        <v-btn color="blue darken-1" flat @click="close_dialog()">{{$t('action.close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="add_member_dialog.show" scrollable persistent max-width="400px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-form ref="addMemberForm" method="post" :action="add_member_dialog.form.action" @success="addInvitationSuccess">
                <input type="hidden" name="team_id" v-model="item.id">
                <v-card>
                    <v-toolbar dark color="primary" height="80">
                        <v-toolbar-title>{{$t('team.invite_user')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="closeAddMemberDialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="v-dialog-body">
                        <v-container grid-list-md>
                            <v-layout row wrap>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('team.invitation_url')"
                                        :value="item.invitation_url"
                                        hide-details
                                        outline
                                        readonly
                                    >
                                        <template slot="append">
                                            <v-menu bottom left>
                                                <v-icon slot="activator">more_vert</v-icon>
                                                <v-list>
                                                    <v-list-tile
                                                        @click="copyUrl(item.invitation_url)"
                                                    >
                                                        <v-list-tile-title>{{$t('action.copy')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="gotoUrl(item.invitation_url)"
                                                    >
                                                        <v-list-tile-title>{{$t('action.open')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </v-text-field>
                                </v-flex>

                                <v-flex class="text-sm-center">
                                    or
                                </v-flex>

                                <v-flex xs12 v-show="add_member_dialog.form.errors.general!==''">
                                    <v-alert
                                        :value="add_member_dialog.form.errors.general!==''"
                                        type="error"
                                    >
                                        {{add_member_dialog.form.errors.general}}
                                    </v-alert>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        type="email"
                                        name="email"
                                        :error-messages="add_member_dialog.form.errors.email"
                                        outline
                                        :label="$t('team.user_email')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            type="submit"
                            ref="submit"
                            color="blue darken-1"
                            flat
                            :loading="add_member_dialog.form.loading"
                        >
                            {{$t('action.add')}}
                        </v-btn>
                        <v-btn color="blue darken-1" flat @click="closeAddMemberDialog()">{{$t('action.close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    import {UrlServices} from "~/utils/url-manager";
    import FormHandling from '~/utils/data/form-handling'
    import RequestHandler from "~/utils/request-handler";

    export default {
        name: "TeamEditDialog",
        props: {
            value: Boolean,
            item: Object
        },
        data() {
            return {

                rules: {
                    required: value => !!value || this.$t('form.field_required')
                },
                form: {
                    action: UrlServices.createUrl({'name': 'api_team_save'}),
                    errors: {
                        general: '',
                        name: ''
                    },
                    loading: false,
                },
                form_handling_object: null,
                add_member_dialog: {
                    show: false,
                    form: {
                        action: UrlServices.createUrl({'name': 'api_team_invitation_save'}),
                        errors: {
                            general: "",
                            email: ""
                        },
                        loading: false
                    },
                    form_handling_object: null
                }
            };
        },
        watch: {
            item: async function(item) {
                // this.team = _.extend({}, item);
                if(!item.id){
                    this.form_handling_object.formReset();
                    await this.$nextTick();
                }
            }
        },
        computed: {
            formTitle () {
                return (this.item.id > 0) ? this.$t('team.edit_team') : this.$t('team.new_team')
            }
        },
        methods: {
            editSuccess(data) {
                this.$emit('success', data);
                this.close_dialog();
            },
            openAddMemberDialog() {
                this.add_member_dialog.show = true;
            },
            closeAddMemberDialog() {
                this.add_member_dialog.show = false;
                this.add_member_dialog.form.errors.general = "";
                this.add_member_dialog.form_handling_object.formReset();
            },
            isTeamOwner(item) {
                let user_id = getApp.$store.state.user_info.id;
                return user_id == item.creator_id;
            },
            kickSuccess(user_id) {
                this.$emit('kick_success', {
                    'user_id': user_id,
                    'team_id': this.item.id
                });
            },
            removeInvitationSuccess(invitation_id) {
                this.$emit('remove_invitation_success', {
                    'invitation_id': invitation_id,
                    'team_id': this.item.id
                });
            },
            kickMember(user) {
                let me = this;
                this.$root.$confirm(
                    this.$t('team.kick_member'),
                    this.$t('team.kick_member_msg', {
                        'user_name': user.name
                    })).then((confirm) => {
                    if (confirm) {
                        RequestHandler.Post(UrlServices.createUrl({'name': 'api_team_kick'}), {
                            id: me.item.id,
                            user_id: user.id
                        }, {
                            'success': function (data) {
                                me.kickSuccess(user.id);

                                getApp.snackbar = {
                                    show: true,
                                    color: 'green',
                                    text: data.msg,
                                    timeout: 3000
                                };
                            },
                            'error': function (data) {
                                getApp.snackbar = {
                                    show: true,
                                    color: 'red',
                                    text: data.msg,
                                    timeout: 3000
                                };
                            }
                        });
                    }
                });
            },
            removeInvitation(invitation) {
                let me = this;
                this.$root.$confirm(
                    this.$t('team.remove_invitation'),
                    this.$t('team.remove_invitation_msg', {
                        'email': invitation.email
                    })).then((confirm) => {
                    if (confirm) {
                        RequestHandler.Post(UrlServices.createUrl({'name': 'api_team_invitation_delete'}), {
                            team_id: me.item.id,
                            invitation_id: invitation.id
                        }, {
                            'success': function (data) {
                                me.removeInvitationSuccess(invitation.id);

                                getApp.snackbar = {
                                    show: true,
                                    color: 'green',
                                    text: data.msg,
                                    timeout: 3000
                                };
                            },
                            'error': function (data) {
                                getApp.snackbar = {
                                    show: true,
                                    color: 'red',
                                    text: data.msg,
                                    timeout: 3000
                                };
                            }
                        });
                    }
                });
            },
            addInvitationSuccess(data) {
                this.$emit('add_invitation_success', data);
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: this.$t('app.msg_create_success'),
                    timeout: 3000
                };
                this.closeAddMemberDialog();
            },
            close_dialog() {
                this.$emit('input', false);
                this.form.errors.general = "";
            },
            copyUrl(url) {
                let me = this;
                this.$copyText(url).then(function() {
                    getApp.snackbar = {
                        show: true,
                        color: 'green',
                        text: me.$t('app.msg_copy_success'),
                        timeout: 3000
                    };
                }, function(e) {
                    console.log('Can not copy');
                    console.log(e);
                })
            },
            gotoUrl(url) {
                window.open(url, '_blank');
            },
        },
        mounted() {
            this.form_handling_object = new FormHandling(this, "editTeamForm", this.form);
            this.add_member_dialog.form_handling_object = new FormHandling(this, "addMemberForm", this.add_member_dialog.form);
        }
    }
</script>

<style scoped>
    .member-list-wrapper {
        max-height: 300px;
        overflow-y: auto;
    }
</style>
